import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scale, verticalOffset = 0, gradientStop1, gradientStop2 }) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`
  const transformOrigin = '24 8.2'

  return (
    <g transform={`scale(${scale},${scale}) translate(0,${verticalOffset})`} transform-origin={transformOrigin}>
      <path
        d="M11.3799 15.7699C6.61994 15.7699 5.17996 13.5899 4.45996 11.6899C3.58996 9.38994 3.18992 4.91992 3.16992 4.72992L3.66992 4.68994C3.66992 4.73994 4.07993 9.27993 4.92993 11.5199C5.63993 13.3799 6.94995 15.2799 11.39 15.2799C15.67 15.2799 18.0599 14.1699 19.1299 11.6699C19.4599 10.9099 19.68 9.75993 19.9 8.64993C20.26 6.79993 20.5699 5.20993 21.3599 4.98993L21.4899 5.46994C20.9999 5.60994 20.6599 7.34994 20.3799 8.74994C20.1599 9.87994 19.93 11.0599 19.58 11.8699C18.44 14.5299 15.8299 15.7699 11.3799 15.7699Z"
        fill={`url(#${randomGradientId1})`}
      />
      <path
        d="M36.5397 15.7699C32.0897 15.7699 29.4897 14.5299 28.3397 11.8599C27.9897 11.0499 27.7597 9.87993 27.5397 8.73993C27.2697 7.33993 26.9297 5.59994 26.4297 5.46994L26.5597 4.98993C27.3497 5.20993 27.6597 6.80993 28.0197 8.64993C28.2397 9.75993 28.4597 10.9099 28.7897 11.6699C29.8597 14.1599 32.2497 15.2799 36.5297 15.2799C40.9597 15.2799 42.2797 13.3799 42.9897 11.5199C43.8397 9.27993 44.2497 4.73994 44.2497 4.68994L44.7497 4.72992C44.7297 4.91992 44.3297 9.38994 43.4597 11.6899C42.7397 13.5899 41.2997 15.7699 36.5397 15.7699Z"
        fill={`url(#${randomGradientId2})`}
      />
      <path
        d="M36.6499 0.660009C29.7099 0.550009 28.4498 1.92999 27.4698 2.69999C26.8398 3.18999 26.4799 3.33001 25.7899 3.22001C25.2099 3.13001 24.3099 3.07999 23.9199 3.07999C23.5299 3.07999 22.7199 3.12001 22.1399 3.22001C21.4499 3.33001 21.0899 3.18999 20.4599 2.69999C19.4799 1.92999 18.2099 0.550009 11.2799 0.660009C4.94991 0.760009 2.73986 2.01999 0.109863 2.19999L0.269897 5.19001C0.269897 5.19001 2.84987 5.37999 3.54987 7.76999C3.54987 7.76999 3.8299 8.01999 4.0199 7.50998C4.1899 5.60998 5.17986 3.63001 8.47986 2.97001C13.1999 2.03001 17.5899 2.95999 19.0399 4.82999C20.1299 6.23999 20.0299 8.13001 20.0299 8.13001C20.0299 8.13001 19.9799 8.71001 20.4799 8.25001C21.2199 6.02001 22.5798 5.54998 23.9698 5.53998V5.51999V5.53998C25.3598 5.54998 26.7199 6.02001 27.4599 8.25001C27.9699 8.70001 27.9099 8.13001 27.9099 8.13001C27.9099 8.13001 27.8099 6.22999 28.8999 4.82999C30.3499 2.95999 34.7299 2.03001 39.4599 2.97001C42.7599 3.63001 43.7499 5.63998 43.9199 7.53998C44.1099 8.04998 44.3899 7.75998 44.3899 7.75998C45.0899 5.36998 47.6699 5.19001 47.6699 5.19001L47.8299 2.19999C45.1899 2.01999 42.9799 0.760009 36.6499 0.660009Z"
        fill="#010101"
      />
      <path
        d="M46.1696 4.25995C46.4623 4.25995 46.6996 4.02266 46.6996 3.72995C46.6996 3.43724 46.4623 3.19995 46.1696 3.19995C45.8769 3.19995 45.6396 3.43724 45.6396 3.72995C45.6396 4.02266 45.8769 4.25995 46.1696 4.25995Z"
        fill="white"
      />
      <path
        d="M1.74976 4.25995C2.04247 4.25995 2.27979 4.02266 2.27979 3.72995C2.27979 3.43724 2.04247 3.19995 1.74976 3.19995C1.45704 3.19995 1.21973 3.43724 1.21973 3.72995C1.21973 4.02266 1.45704 4.25995 1.74976 4.25995Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="12.327"
          y1="13.7625"
          x2="12.327"
          y2="8.52594"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.2267" stopColor={gradientStop1} />
          <stop offset="1" stopColor={gradientStop2} />
        </linearGradient>
        <linearGradient
          id={randomGradientId2}
          x1="35.5914"
          y1="13.7625"
          x2="35.5914"
          y2="8.52594"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.2267" stopColor={gradientStop1} />
          <stop offset="1" stopColor={gradientStop2} />
        </linearGradient>
      </defs>
    </g>
  )
}
